const t = {
  computed: {
    imageUrl() {
      let e = "";
      return this.asset.type.name === "Clip Art" ? (e = this.asset.clean_media_files.find((i) => i.format_id === 9), e ? e.url : this.asset.clean_media_files.find((i) => i.format_id === 36).url) : (e = this.asset.clean_media_files.find((i) => i.format_id === 38), e || (e = this.asset.clean_media_files.find((i) => i.format_id === 37), e) || (e = this.asset.clean_media_files.find((i) => i.format_id === 36), e) ? e.url : (window.ga && window.ga("send", "event", "assetdetailimagenotfound", this.asset.id), e));
    }
  }
};
export {
  t as default
};
